import React, { useState, useEffect } from 'react';
import usePortalAuth from '../../../auth/usePortalAuth';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ScalableShieldSpinner from '../LoadingSpinner/ScalableShieldSpinner';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Paper } from '@material-ui/core';
import AlertsTable from './AlertsTable';
import AlertsTableCollapsible from './AlertsTableCollapsible';
import EmptyAlertsTable from './EmptyAlertsTable';
import useFilterForm from '../CustomHooks/useFilterForm';
import useCheckPermissionsForAPICalls from '../CustomHooks/useCheckPermissionsForAPICalls';
import useChangePageTitle from '../CustomHooks/useChangePageTitle';
import './Alerts.css';
import basePCUrl from '../../../Globals';
import { fetchApiData } from '../../../utils/service';
import { useQuery } from 'react-query';


const Alerts = (props) => {
  useChangePageTitle('Alerts');

  const preferredLanguage = props.preferredLanguage
  const getTranslation = props. getTranslation

  const [alertData, setAlertData] = useState(props.alertData);
  const [alertAmount, setAlertAmount] = useState();
  const [isLoading, setIsLoading] = useState();

  const { getAccessTokenSilently } = usePortalAuth();

  const useStyles = makeStyles((theme) => ({
    root: {
      padding: theme.spacing(3),
      background: theme.palette.type === 'dark' ? theme.palette.background.default : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      minHeight: '100vh',
    },
    headerCard: {
      padding: theme.spacing(3),
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 12,
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
      marginBottom: theme.spacing(3),
    },
  title: {
      fontWeight: 700,
      color: theme.palette.type === 'dark' ? theme.palette.text.primary : '#1a237e',
      textAlign: 'center',
    },
    tableContainer: {
      padding: 0,
    },
    spinnerContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '400px',
    },
  }));

  const classes = useStyles();


  const pushToErrorPage = () => {
    props.history.push('/Dashboard/Error');
  };


  if (props.selectedClient === undefined || props.selectedClient === '') {
    var clientId = props.defaultClient;
  } else{
    var clientId = props.selectedClient;
  }



  const getAlertDetails = useQuery(
    ['getAlertDetails',],
    async () => {
      const token = await getAccessTokenSilently();
      return fetchApiData(
        basePCUrl,
        token,
        'getAlertDetails',
        props.accessLevel,
        clientId
      );
    },
   // { enabled: false }
  );

  
  // const refreshCompanyAlerts = async () => {
  //   setIsLoading(true);
  //   const token = await getAccessTokenSilently();

  //       var fetchDetails = {
  //         //credentials: 'same-origin',
  //         method: 'get',
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           'Content-Type': 'application/json',
  //           Action: 'getAlertDetails',
  //           id: clientId,
  //         },
  //       };

  //     fetch(baseV2Url, fetchDetails)
  //       .then((response) => {
  //         if (response.status !== 200) {
  //           pushToErrorPage();
  //           console.log('Looks like there was a problem. Status Code: ' + response.status);
  //           //setError(true);
  //           // console.log(error);
  //           return;
  //         }

  //         response.json().then((data) => {
  //           if (data.status === 'Error') {
  //             console.log('Alert Fetch Error');
  //           } else {
  //             setAlertData(data);
  //             setIsLoading(false);
  //             //setAlertAmount(data.portalAlerts.length);
  //             //console.log(data);
  //           }
  //         });
  //       })
  //       .catch(function (err) {
  //         console.log('Fetch Error :-S', err);
  //       });
  // };

  useEffect(() => {
    //getCompanyAlerts();

    //refreshCompanyAlerts();
    getAlertDetails.refetch()
    setAlertData(getAlertDetails?.data)
  }, [clientId]);

  //console.log(alertData)

  return (
    <div className={classes.root}>
      <Paper className={classes.headerCard}>
        <Typography variant="h3" className={classes.title}>
          {getTranslation("Alerts", preferredLanguage)}
        </Typography>
      </Paper>

      <Box className={classes.tableContainer}>
        {getAlertDetails.isLoading ? (
          <div className={classes.spinnerContainer}>
            <ScalableShieldSpinner size={150} logoSrc={require('../../../Assets/Logos/Shield.png')} />
          </div>
        ) : !getAlertDetails.isLoading && getAlertDetails.data && getAlertDetails.data.length >= 1 ? (
          <AlertsTableCollapsible
            history={props.history}
            clientId={clientId}
            accessLevel={props.accessLevel}
            refreshAlerts={() => getAlertDetails.refetch()}
            isLoading={getAlertDetails.isLoading}
            alertData={getAlertDetails.data}
            getTranslation={getTranslation}
            preferredLanguage={preferredLanguage}
          />
        ) : !getAlertDetails.isLoading && getAlertDetails.data?.length === 0 ? (
          <EmptyAlertsTable history={props.history} refreshAlerts={() => getAlertDetails.refetch()} />
        ) : (
          <span></span>
        )}
      </Box>
    </div>
  );
};
export default Alerts;

